import { z } from "zod";

export const PolicyTypesEnum = {
  DIRECT: "DirectPolicy",
  DAILY: "DailyPolicy",
  QUICK_PLAN_CONDITIONAL: "QuickPlanConditional",
  GREAT_PLAN_CONDITIONAL: "GreatPlanConditional",
  DAILY_REFERRAL: "DailyReferralPolicy",
  DIRECT_REFERRAL: "DirectReferralPolicy",
} as const;

export const PolicyTypesSchema = z.enum([
  PolicyTypesEnum.DIRECT,
  PolicyTypesEnum.DAILY,
  PolicyTypesEnum.QUICK_PLAN_CONDITIONAL,
  PolicyTypesEnum.GREAT_PLAN_CONDITIONAL,
  PolicyTypesEnum.DAILY_REFERRAL,
  PolicyTypesEnum.DIRECT_REFERRAL,
]);

export type PolicyTypes = z.infer<typeof PolicyTypesSchema>;